"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addApi = addApi;
exports.bindByCodeApi = bindByCodeApi;
exports.bindImportByIdsApi = bindImportByIdsApi;
exports.bindProductApi = bindProductApi;
exports.bindSelectListApi = bindSelectListApi;
exports.bindSpuLabelListApi = bindSpuLabelListApi;
exports.deleteApi = deleteApi;
exports.deleteBindApi = deleteBindApi;
exports.detailApi = detailApi;
exports.listApi = listApi;
exports.productListApi = productListApi;
exports.updateApi = updateApi;
exports.updateSortApi = updateSortApi;
exports.updateStatusApi = updateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** 新增/编辑 body：与 store/nameLabel/save、update 文档对齐 */
function buildPayload() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$withId = _ref.withId,
    withId = _ref$withId === void 0 ? false : _ref$withId;
  var payload = {
    labelImage: datas.labelImage || '',
    labelName: (datas.labelName || '').trim(),
    productSource: Number(datas.productSource) || 1,
    status: datas.status === 0 || datas.status === '0' ? 0 : 1
  };
  // 选填
  if (datas.labelPosition != null && datas.labelPosition !== '') {
    payload.labelPosition = Number(datas.labelPosition);
  }
  if (datas.priceType != null && datas.priceType !== '') {
    payload.priceType = Number(datas.priceType);
  }
  if (datas.sort != null && datas.sort !== '') {
    payload.sort = Number(datas.sort);
  }
  // 更新必传 id
  if (withId) {
    payload.id = datas.id;
  }
  return payload;
}

/** 列表 POST /admin/store/nameLabel/list */
function listApi() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = pram || {},
    labelName = _ref2.labelName,
    page = _ref2.page,
    limit = _ref2.limit,
    status = _ref2.status;
  var data = {};
  if (labelName != null && labelName !== '') data.labelName = labelName;
  if (page != null && page !== '') data.page = Number(page);
  if (limit != null && limit !== '') data.limit = Number(limit);
  if (status != null && status !== '') data.status = Number(status);
  return (0, _request.default)({
    url: '/admin/store/nameLabel/list',
    method: 'post',
    data: data
  });
}

/** 新增 POST /admin/store/nameLabel/save */
function addApi(pram) {
  return (0, _request.default)({
    url: '/admin/store/nameLabel/save',
    method: 'post',
    data: buildPayload(pram)
  });
}

/** 更新 POST /admin/store/nameLabel/update */
function updateApi(pram) {
  return (0, _request.default)({
    url: '/admin/store/nameLabel/update',
    method: 'post',
    data: buildPayload(pram, {
      withId: true
    })
  });
}

/** 更新状态/排序 POST /admin/store/nameLabel/updateStatus */
function updateStatusApi() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = {
    id: pram.id
  };
  if (pram.status != null && pram.status !== '') data.status = Number(pram.status);
  if (pram.sort != null && pram.sort !== '') data.sort = Number(pram.sort);
  return (0, _request.default)({
    url: '/admin/store/nameLabel/updateStatus',
    method: 'post',
    data: data
  });
}

/** 更新排序（走 updateStatus，body: id + sort） */
function updateSortApi(pram) {
  return updateStatusApi({
    id: pram.id,
    sort: Number(pram.sort) || 0
  });
}

/** 删除 POST /admin/store/nameLabel/delete */
function deleteApi(pram) {
  return (0, _request.default)({
    url: '/admin/store/nameLabel/delete',
    method: 'post',
    data: {
      id: pram.id
    }
  });
}

/** 详情 POST /admin/store/nameLabel/info */
function detailApi(id) {
  return (0, _request.default)({
    url: '/admin/store/nameLabel/info',
    method: 'post',
    data: {
      id: id
    }
  });
}

/** 绑定商品列表 POST /admin/store/nameLabel/bind/list */
function productListApi() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = pram || {},
    labelId = _ref3.labelId,
    productName = _ref3.productName,
    skuId = _ref3.skuId,
    page = _ref3.page,
    limit = _ref3.limit;
  var data = {
    labelId: labelId
  };
  if (page != null && page !== '') data.page = Number(page);
  if (limit != null && limit !== '') data.limit = Number(limit);
  if (productName != null && productName !== '') data.productName = String(productName).trim().slice(0, 50);
  if (skuId != null && skuId !== '') data.skuId = String(skuId).trim().slice(0, 50);
  return (0, _request.default)({
    url: '/admin/store/nameLabel/bind/list',
    method: 'post',
    data: data
  });
}

/** 选择商品列表 POST /admin/store/nameLabel/bind/select/list */
function bindSelectListApi() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = pram || {},
    productName = _ref4.productName,
    skuId = _ref4.skuId,
    page = _ref4.page,
    limit = _ref4.limit;
  var data = {};
  if (page != null && page !== '') data.page = Number(page);
  if (limit != null && limit !== '') data.limit = Number(limit);
  if (productName != null && productName !== '') data.productName = String(productName).trim().slice(0, 50);
  if (skuId != null && skuId !== '') data.skuId = String(skuId).trim().slice(0, 50);
  return (0, _request.default)({
    url: '/admin/store/nameLabel/bind/select/list',
    method: 'post',
    data: data
  }).then(function () {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var list = res && Array.isArray(res.list) ? res.list : [];
    return _objectSpread(_objectSpread({}, res), {}, {
      list: list.map(function (item) {
        var _ref5 = item || {},
          category = _ref5.category,
          code = _ref5.code,
          image = _ref5.image,
          name = _ref5.name,
          price = _ref5.price;
        var skuId = item.skuId != null ? item.skuId : item.id;
        return _objectSpread(_objectSpread({}, item), {}, {
          // 选品组件默认按 id 去重，名称标签列表以 skuId 为准
          id: skuId,
          skuId: skuId,
          skuCode: item.skuCode || code,
          skuName: item.skuName || name,
          storeName: item.storeName || name,
          cateName: item.cateName || category,
          otPrice: item.otPrice != null ? item.otPrice : price,
          image: item.image || image
        });
      })
    });
  });
}

/** 选择商品确认绑定 POST /admin/store/nameLabel/bind/import/byIds */
function bindImportByIdsApi() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref6 = pram || {},
    labelId = _ref6.labelId,
    skuIds = _ref6.skuIds,
    confirmAction = _ref6.confirmAction;
  var data = {
    labelId: labelId,
    skuIds: (skuIds || []).map(function (id) {
      return Number(id);
    }).filter(function (id) {
      return !Number.isNaN(id);
    })
  };
  if (confirmAction != null && confirmAction !== '') {
    data.confirmAction = Number(confirmAction);
  }
  return (0, _request.default)({
    url: '/admin/store/nameLabel/bind/import/byIds',
    method: 'post',
    data: data
  });
}

/** 绑定商品 */
function bindProductApi(data) {
  return (0, _request.default)({
    url: '/admin/store/nameLabel/bindProduct',
    method: 'post',
    data: data
  });
}

/** 移除绑定商品 POST /admin/store/nameLabel/bind/delete */
function deleteBindApi() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/store/nameLabel/bind/delete',
    method: 'post',
    data: {
      labelId: pram.labelId,
      skuIds: (pram.skuIds || []).map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return !Number.isNaN(id);
      })
    }
  });
}

/** 导入绑定 */
function bindByCodeApi(data) {
  var _ref7 = data || {},
    id = _ref7.id,
    type = _ref7.type,
    skuIdList = _ref7.skuIdList,
    spuIdList = _ref7.spuIdList,
    productCodeList = _ref7.productCodeList,
    overwrite = _ref7.overwrite;
  return (0, _request.default)({
    url: '/admin/store/nameLabel/bindProductByCode',
    method: 'post',
    data: {
      id: id,
      type: type,
      skuIdList: skuIdList || spuIdList || productCodeList,
      overwrite: overwrite ? 1 : 0
    }
  });
}

/** 根据skuId批量查询已绑定标签 */
function bindSpuLabelListApi() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/store/nameLabel/bind/spu/label/list',
    method: 'post',
    data: {
      skuIdList: data.skuIdList || data.spuIdList || []
    }
  });
}